import payment from "@/api/payment";

export default {
  state: {
  },
  mutations: {
  },
  actions: {
    async createSubscription(context, { token }) {
      const params = {
        card_id: token,
        account_id: await context.dispatch("showAccountID"),
        user_id: await context.dispatch("showUserId"),
        user_name: await context.dispatch("showUsername"),
      };
      const ret = await payment.insert(params);
      return ret;
    },
  },
  getters: {
  }
};
